module.exports = __webpack_public_path__ + "static/media/Balloon_green.f8b3203a.png";